module.exports = __webpack_public_path__ + "img/left-arm_hover.08f3045a.png";